// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__tQ0-v","footer":"ReportModalFilter_footer__MTt0O"};